// extracted by mini-css-extract-plugin
module.exports = {"addToFavorites":"zw","addToFavoritesButton":"Aw"};